import { showErrorMessage } from "../helpers/messagesHelper";

function useErrorHandler() {
  return (error: any, setBackendFormErrors: any = null) => {
    const status = error?.response?.status;
    const data = error?.response?.data;
    const backendMessage =
      (data && (data.error || data.message)) ||
      (typeof data === "string" ? data : null);

    if (status === 401) {
      const message = backendMessage;
      if (message === "Unauthenticated." || message === "Unauthenticated") {
        window.location.href =
          "/login?message=Unauthenticated.&messageType=error";
      } else if (message) {
        showErrorMessage(message);
      } else {
        showErrorMessage("unauthorized_error");
      }
      return;
    }

    if (status === 422) {
      const formattedError = formatErrors(data.errors);
      if (setBackendFormErrors) {
        setBackendFormErrors(formattedError);
      }
      return;
    }

    // Para otros errores mostramos el mensaje explicito si hay
    if (backendMessage) {
      showErrorMessage(backendMessage);
    } else {
      showErrorMessage("server_error");
    }
  };
}

function formatErrors(errors: any) {
  let formattedErrors: any = {};
  for (let key in errors) {
    // si key no contiene un punto, es un error del formulario
    if (!key.includes(".")) {
      formattedErrors[key] = { __errors: errors[key] };
      continue;
    } else {
      // Tenemos que de forma dinamica sacar las keys de key separando por punto y setear el objeto de formattedErrores con las keys sacadas y en la ultima key guardar el error
      let keys = key.split(".");
      let lastKey = keys.pop();
      let currentObject = formattedErrors;
      keys.forEach((key) => {
        if (!currentObject[key]) {
          currentObject[key] = {};
        }
        currentObject = currentObject[key];
      });
      if (lastKey) {
        currentObject[lastKey] = { __errors: errors[key] };
      }
    }
  }
  return formattedErrors;
}

export default useErrorHandler;
